<template>
  <div class="bootcard-batch-dialog">
    <custom-dialog
      width="1200px"
      :title="$t('fms_bank_flow_batch_writeOff_dialog.pi_liang_he_xiao')"
      :visible="visible"
      v-on="$listeners"
    >
      <div class="dialog-body">
        <div class="btn-group">
          <div class="btn-add ub-f1">
            <input
              type="file"
              ref="file"
              id="file"
              multiple="multiple"
              @change="handleFile"
            />
            <div style="display: inline-block">
              <i class="icon icon-add"></i>
              <span>
                {{ $t('fms_bank_flow_batch_writeOff_dialog.xzmbgswj') }}
              </span>
            </div>
          </div>
          <!-- <el-button style="float:right;" size="big" @click="onDownloadTpl">
            <i class="icon icon-daochu"></i>
            {{ $t('page_content_bootcard_tpl }}
          </el-button> -->
          <div
            class="btn-tpl"
            @click="onDownloadTpl"
          >
            <div style="display: inline-block">
              <i class="icon icon-daochu"></i>
              <span>{{ $t('fms_bank_flow_batch_writeOff_dialog.xzmbwj') }}</span>
            </div>
          </div>
        </div>
        <div class="tip-box">
          <div
            v-if="tip"
            class="result"
            v-html="tip"
          ></div>
        </div>
        <div
          class="search"
          style="height: 40px; overflow: hidden; "
        >
          <el-form :inline="true">
            <el-form-item>
              <el-button
                @click="showOk = true"
                :type="showOk ? 'primary' : ''"
                :plain="!showOk"
              >
                {{ $t('fms_bank_flow_batch_writeOff_dialog.tong_guo_yan_zheng') }}（{{ okNum }}）
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                @click="showOk = false"
                :type="!showOk ? 'primary' : ''"
                :plain="showOk"
              >
              {{ $t('fms_bank_flow_batch_writeOff_dialog.yi_chang_shu_ju') }}（{{ failNum }}）
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 验证通过 -->
        <div v-show="showOk">
          <custom-table
            :data="okList"
            :tableCode="tableCode"
            @filter="filterChange"
            @sort="sortChange"
            :filterArr="['errorMsg']"
             :slots="['invoiceNum']"
          >
        <template
            slot="invoiceNum"
            slot-scope="scope"
          >

            <template>
              <span
                :class="'cell-link'"
                @click="onInvoiceDetails(scope.row.invoiceId, false)"
              >{{ scope.row.invoiceNum || '-' }}</span>
            </template>
          </template>

        </custom-table>
          <div class="table-page">
            <el-pagination
              border
              v-if="okNum"
              @size-change="onSizeChange1"
              @current-change="onCurrentPage1"
              :current-page="failForm.pageNum"
              :page-sizes="pageSizeList"
              :page-size="failForm.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="okNum"
            ></el-pagination>
          </div>
        </div>
        <!-- 验证失败 -->
        <div v-show="!showOk">
          <custom-table
            :data="failList"
            :tableCode="tableCode"
            @filter="filterChange"
            @sort="sortChange"
          >
            <!-- <el-table-column
              v-if="$t('page_content_err_reason"
              prop="errorMsg"
              :label="$t('page_content_err_reason"
              show-overflow-tooltip
              width="220px"
            ></el-table-column> -->
          </custom-table>
          <div class="table-page">
            <el-pagination
              border
              v-if="failNum"
              @size-change="onSizeChange2"
              @current-change="onCurrentPage2"
              :current-page="failForm.pageNum"
              :page-sizes="pageSizeList"
              :page-size="failForm.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="failNum"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="closeDialog">
          {{
          $t('Common.com_cancel')
          }}
        </el-button>
        <el-button
          v-if="showOk"
          type="primary"
          :disabled="!okForm.flag || !okNum"
          :loading="submitLoading"
          @click="saveBatchImport"
        >
          {{$t('fms_bank_flow_batch_writeOff_dialog.que_ding_dao_ru')}}
        </el-button>
        <el-button
          v-else
          type="primary"
          :disabled="!okForm.flag || !failNum"
          @click="onDownloadFail"
        >{{$t('Common.com_export') }}</el-button>
      </div>
    </custom-dialog>
    <!-- 发票详情 -->
    <invoice-details-dialog
      v-if="dialogVisible1"
      :model="dialogModel1"
      @close="dialogVisible1 = false"
    ></invoice-details-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import invoiceDetailsDialog from '@/pages/fms/components/invoice_details_dialog.vue';

export default {
  // props: {
  //   value: {
  //     type: Boolean,
  //     default: false
  //   },
  //   data: [String, Object, Array],
  //   model: {
  //     type: Object,
  //     default() {
  //       return {
  //         title: ''
  //       };
  //     }
  //   }
  // },
  mixins: [dialogMixins],
  components: {
    invoiceDetailsDialog
  },
  data() {
    return {
      // visible: false,
      tableCode: 'bankFlow_batch_writeOff',
      submitLoading: false,
      okForm: {
        flag: '',
        type: 'ok',
        pageNum: 1,
        pageSize: 50,
      },
      failForm: {
        flag: '',
        type: 'fail',
        pageNum: 1,
        pageSize: 50,
      },
      failList: [],
      failNum: 0,
      okList: [],
      okNum: 0,
      showOk: true,
      tip: '',
      dialogVisible1: false,
      dialogModel1: {},
    };
  },
  mounted() {
    this.resetOkForm = JSON.stringify(this.okForm);
    this.resetFailForm = JSON.stringify(this.failForm);
    this.init();
  },
  methods: {
    // 初始化
    init: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.okForm = JSON.parse(this.resetOkForm);
      this.failForm = JSON.parse(this.resetFailForm);
      this.failList = [];
      this.failNum = 0;
      this.okList = [];
      this.okNum = 0;
      this.showOk = true;
      this.tip = '';
      // this.getTableColumn();
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 模板下载
    onDownloadTpl: function () {
      this.$exportFlie(apis.tradeSellerUnVerifyDownloadTemplate);
    },
    // 文件上传
    handleFile: function (e) {
      this.$postFile(apis.tradeSellerVerifyExcel, e).then((res) => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.$refs.file.value = '';
        this.failNum = res.data.failNum || 0;
        this.okNum = res.data.okNum || 0;
        this.okForm.flag = res.data.flag;
        this.failForm.flag = res.data.flag;
        const total = this.failNum + this.okNum;
        this.tip = this.$t('fms_bank_flow_batch_writeOff_dialog.bcydrotqzsspantsbwtg', [total,this.okNum,this.failNum]);
        // 默认获取成功条数
        this.getBatchOk();
        // 失败条数
        this.getBatchFail();
      });
    },
    // 异常导出
    onDownloadFail: function () {
      this.$exportFlie(apis.tradeSellerExcelCheckResultExport, this.failForm);
    },
    // 获取检测列表分页
    getBatchOk: function () {
      this.$getJSON(apis.tradeSelleExcelCheckPage, this.okForm).then((res) => {
        this.okList = res.data.list;
      });
    },
    // 获取检测列表分页
    getBatchFail: function () {
      this.$getJSON(apis.tradeSelleExcelCheckPage, this.failForm).then((res) => {
        this.failList = res.data.list;
      });
    },
    // 切换页
    onCurrentPage1: function (page) {
      this.okForm.pageNum = page;
      this.getBatchOk();
    },
    // 切换每页数量
    onSizeChange1: function (size) {
      this.okForm.pageSize = size;
      this.getBatchOk();
    },
    // 切换页
    onCurrentPage2: function (page) {
      this.failForm.pageNum = page;
      this.getBatchFail();
    },
    // 切换每页数量
    onSizeChange2: function (size) {
      this.failForm.pageSize = size;
      this.getBatchFail();
    },
    // 保存入库
    saveBatchImport: function () {
      // 如果正在加载中，直接返回，防止重复提交
      if (this.submitLoading) {
        return;
      }
      this.submitLoading = true;
      this.$postJSON(`${apis.tradeSellerVerifyExcelSave}/${this.okForm.flag}`, this.failForm).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.closeDialog();
        this.$emit('success');

      }).finally(() => {
        // 无论成功或失败，都重置加载状态
        this.submitLoading = false;
      });
    },
    onInvoiceDetails: function (invoiceId, isRedInvoice) {
      this.dialogModel1.type = isRedInvoice;
      this.dialogModel1.title = this.$t('fms_bank_flow_batch_writeOff_dialog.fa_piao_xiang_qing');
      this.dialogModel1.invoiceId = invoiceId;
      this.dialogVisible1 = true;
    },
  },
};
</script>

<style lang="scss">
.bootcard-batch-dialog {
  .btn-group {
    margin-bottom: 20px;
    overflow: hidden;

    .btn-add {
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: rgba(245, 245, 245, 1);
      border: 1px dashed rgba(228, 228, 228, 1);
      color: #333333;
      font-size: 12px;
      position: relative;
      float: left;
      width: 980px;

      input {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        display: block;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
      }
      .icon {
        color: #00afff;
        font-size: 12px;
        margin-right: 4px;
      }
    }
    .btn-tpl {
      float: right;
      width: 162px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      border: 1px solid rgba(228, 228, 228, 1);
      margin-left: 10px;
      color: #333333;
      font-size: 12px;
      cursor: pointer;
      .icon {
        color: #00afff;
        font-size: 12px;
        margin-right: 4px;
      }
    }

    // .tip-tpl {
    //   color: #0d9ae0;
    //   cursor: pointer;
    // }
  }
  .tip-box {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    .result {
      // padding: 6px 10px 0;
      color: #262626;
      font-size: 12px;
      // height: 40px;
      flex: 1;
      align-self: center;
      .ok {
        color: blue;
      }
      .fail {
        color: red;
      }
    }
  }
}
</style>
